const isValidEmail = (email: string) => {
  const regex = /^[^\s@&]+@[^\s@&]+\.[^\s@&]+$/;
  return regex.test(email) && email.length <= 80;
};
export default isValidEmail;
